import React from "react";
import Section1 from "./Section1";
import Rejoindre from "../../components/Rejoindre";
import Carousel from "../../components/Carousel";
import Boutton from "../../components/Button";
import AppPlayLink from "../../components/AppPLayLink";
import SpecialtyCardSlider from "../../components/SpecialtyCard";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import { useTranslation } from "react-i18next";

const Home = () => {
  const {t} = useTranslation();
  return (
    <main>
      <Section1 />
      <section>
        <div id="bottom-sec" className="h-auto  px-4 pt-20 md:pt-40 l	lg:px-48">
          <h1 className="text-center text-4xl md:w-[80%] lg:w-[90%]  mx-auto font-bold text-blue-primary">
          {t('HomePage.section2.titre')}
          </h1>
          <p className="text-center md:w-[70%] lg:text-xl lg:my-8  mx-auto my-5 ">
          {t('HomePage.section2.paraph1')}
          </p>

          <div className="md:h-[150px] h-auto mb-16">
            <SpecialtyCardSlider />
          </div>

          <Boutton
            label={t('HomePage.section2.telecharger')}
            className="bg-blue-primary mx-auto mt-6 
          text-white hover:bg-blue-header"
          />

          <AppPlayLink />

          <p className="text-center max-md:text-xs">
           {t('HomePage.section2.paraph2')}
          </p>
          {/* <Section2/> */}
        </div>
      </section> 
      <Section3 />
      <Section4 />
      <Section5 />
      <Rejoindre />
      <Carousel />
    </main>
  );
};

export default Home;
